import React, { Component } from "react";
import AppcategoryBean from "../data/bean/app_claim_status_bean";
import AppHeaderBean from "../data/bean/app_header_bean";
import AppTableStatus from "../ui/component/app_table_status/app_table_status";
import GeneralBloc from "./general_bloc";
import FormWebServices from "../service/form_web_services";
import AuthBloc from "./auth_bloc";
import Config from "../Config";
import OccupationMaster from "../data/constant/occupation_master";
import StateMaster from "../data/constant/state_master";
import CityMaster from "../data/constant/city_master";
import CountryMaster from "../data/constant/country_master";

import { ReactComponent as DownloadIcon } from "../Download.svg";
import GeneralWebService from "../service/general_web_service";
import ProposalServices from "../service/proposal_web_services";
import LanguageBloc from "./language_bloc";
import Labels from "../ui/constant/labels";
import FaqWebServices from "../service/faq_web_service";
import DataResult from "../data/bean/data_result";

class FaqBloc extends Component {

    static async getFaqCategories(val) {
        let payload = {
            keyword: val
        }
        try {
            let response = await FaqWebServices.getFaqData('faq_categories', payload);
            return response;
        } catch (error) {
            let resp = error;
            return new DataResult(false, resp.message);
        }

    }

    static async getFaqByCategory(val, id) {
        let payload = {
            keyword: val,
            category: id
        }
        try {
            let response = await FaqWebServices.getFaqData('faq_by_category', payload);
            return response;
        } catch (error) {
            let resp = error;
            return new DataResult(false, resp.message);
        }

    }

}

export default FaqBloc;
